import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import YouTube from "react-youtube";
import { IoMdClose } from "react-icons/io";
import styled from "styled-components";
import { ButtonBase } from "@material-ui/core";
import { YouTube as YouTubeIcon } from "@material-ui/icons";

const TutorialButton = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 8px;
  background: rgba(255, 0, 0, 0.1);
  transition: background 0.2s ease;
  margin-right: 8px;
  cursor: pointer;
  justify-content: flex-start;

  &:hover {
    background: rgba(255, 0, 0, 0.15);
  }

  .youtube-icon {
    color: #FF0000;
    font-size: 20px;
    min-width: 20px;
  }

  .button-text {
    color: #FF0000;
    font-size: 12px;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    white-space: nowrap;
    margin-left: 6px;
  }

  @media screen and (max-width: 1366px) {
    padding: 4px 10px;
    
    .youtube-icon {
      font-size: 18px;
    }
    
    .button-text {
      font-size: 13px;
    }
  }
`;

const DialogWrapper = styled.div`
  .dialog-header {
    background: #000000;
    padding: 12px;
    display: flex;
    justify-content: flex-end;
  }

  .dialog-content {
    padding: 0;
    padding-bottom: 24px;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 360px;
  }

  .close-button {
    cursor: pointer;
    color: white;
    font-size: 24px;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

function PanelTutorial({ videoId }) {
  const [isOpen, setIsOpen] = useState(false);

  const opts = {
    height: "360",
    width: "640",
    playerVars: {
      autoplay: 0,
      rel: 0,
      modestbranding: 1,
      controls: 1
    },
  };

  return (
    <>
      <TutorialButton onClick={() => setIsOpen(true)}>
        <YouTubeIcon className="youtube-icon" />
        <span className="button-text">Panel Tanıtımı</span>
      </TutorialButton>

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogWrapper>
          <div className="dialog-header">
            <IoMdClose
              className="close-button"
              onClick={() => setIsOpen(false)}
            />
          </div>
          <div className="dialog-content">
            <YouTube
              videoId={videoId}
              opts={opts}
              className="youtube-player"
            />
          </div>
        </DialogWrapper>
      </Dialog>
    </>
  );
}

export default PanelTutorial; 